export const resourcesFr = {
  // Wording mirrors the Django msgids exactly (locale/fr is the source
  // language), so the same control reads the same in both apps.
  menuLabel: "Ressources",
  favorites: {
    expert: "Mes experts favoris",
    tool: "Mes outils favoris",
    financialAid: "Mes aides financières favorites",
  },
  browse: {
    expert: "Experts",
    tool: "Outils",
    financialAid: "Aides financières",
  },
  // One string for all three, as templates/repertoire/_panel_content.html
  // renders a single msgid regardless of which directory the panel shows.
  openFullDirectory: "Ouvrir le répertoire complet",
};
